import Aircraft from '@/models/Aircraft';

// Excel formula:
// ="new Aircraft({type: '" & TRIM($B2 & " " & $C2) & "', manufacturer: '" & $A2 & "', country: '"
// & $D2 & "', years: '" & $E2 & "', spd: '" & $F2 & "', man: '" & $G2 & "', alt: '" & $H2
// & "', roc: '" & $I2 & "', rob: '" & $J2 & "', siz: '" & $K2 & "', front: '" & $L2
// & "', right: '" & $M2 & "', left: '" & $N2 & "', rear: '" & $O2 & "', ammoLimit: '"
// & $P2 & "', gun: '" & $Q2 & "', other: '" & TRIM(CLEAN(SUBSTITUTE(R2, "'", "\'"))) & "',}),"
//

const Aircrafts = [
  new Aircraft({
    type: 'Boomerang',
    manufacturer: 'Commonwealth',
    country: 'Australia',
    years: '1943-1945',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'A-31 Vengeance Mk II',
    manufacturer: 'Vultee',
    country: 'Australia',
    years: 'Okt 42- sept 44',
    spd: '5',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '2',
    front: '4',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'R-31',
    manufacturer: 'Renard',
    country: 'Belgium',
    years: '1935-1940',
    spd: '3',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '8',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B-239 Buffalo',
    manufacturer: 'Brewster',
    country: 'Finland',
    years: '1941-1945',
    spd: '6',
    man: '6',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '15',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: '143M',
    manufacturer: 'Amiot',
    country: 'France',
    years: 'Juli 1935-1944',
    spd: '4',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '1',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'MB-152',
    manufacturer: 'Bloch',
    country: 'France',
    years: '1938- dec 1942',
    spd: '6',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'When firing at ALT 4 and above roll additional d6 when firing. Guns will jam on a roll of 1 or 2',
  }),
  new Aircraft({
    type: 'MB-200B.4',
    manufacturer: 'Bloch',
    country: 'France',
    years: '1935-1940',
    spd: '4',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '5',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: '690',
    manufacturer: 'Breguet',
    country: 'France',
    years: '1939-1940',
    spd: '6',
    man: '3',
    alt: '4',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '5',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Forward 1 x 20mm + 2 x MG',
  }),
  new Aircraft({
    type: 'H75-C1',
    manufacturer: 'Curtiss',
    country: 'France',
    years: 'Mrt 39 – 1942',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '3',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: '510',
    manufacturer: 'Dewoitine',
    country: 'France',
    years: 'Juli 1935-1940',
    spd: '4',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: '520',
    manufacturer: 'Dewoitine',
    country: 'France',
    years: 'Jan 1940 – 1953',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '4 x MG + 1 x 20mm',
  }),
  new Aircraft({
    type: 'DB7',
    manufacturer: 'Douglas',
    country: 'France',
    years: 'Mei 40- nov 43',
    spd: '6',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '4',
    front: '4',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '16',
    gun: 'MG',
    other: 'Stats derived from Douglas A20C/Havoc III',
  }),
  new Aircraft({
    type: 'MS406',
    manufacturer: 'Moraine-Saulnier',
    country: 'France',
    years: '1938- 1940',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '5',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: '25',
    manufacturer: 'Potez',
    country: 'France',
    years: '1925-1940',
    spd: '2',
    man: '3',
    alt: '4',
    roc: '1',
    rob: '2',
    siz: '3',
    front: '1',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: '540',
    manufacturer: 'Potez',
    country: 'France',
    years: '1934-1943',
    spd: '3',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '1',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Only used as a transport in WWII',
  }),
  new Aircraft({
    type: '6311',
    manufacturer: 'Potez',
    country: 'France',
    years: 'Oct 1938-1942',
    spd: '5',
    man: '4',
    alt: '5',
    roc: '1',
    rob: '3*',
    siz: '3',
    front: '1',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: '633',
    manufacturer: 'Potez',
    country: 'France',
    years: '1940',
    spd: '5',
    man: '4',
    alt: '5',
    roc: '1',
    rob: '3*',
    siz: '3',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Almost no use by the French. Just 1 mission with 2 aircraft',
  }),
  new Aircraft({
    type: 'Albemarle',
    manufacturer: 'Armstrong Whitworth',
    country: 'GB',
    years: 'Jan 1943-1945',
    spd: '5',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '0',
    right: '4',
    left: '4',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Transport',
  }),
  new Aircraft({
    type: 'Whitley MkV',
    manufacturer: 'Armstrong Whitworth',
    country: 'GB',
    years: 'Mrt 37-1945',
    spd: '3',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '5',
    siz: '5',
    front: '1',
    right: '0',
    left: '0',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Anson MkI',
    manufacturer: 'Avro',
    country: 'GB',
    years: '1936-1968',
    spd: '4',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '4',
    front: '1',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Lancaster',
    manufacturer: 'Avro',
    country: 'GB',
    years: '1942-1963',
    spd: '5',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '6',
    siz: '6',
    front: '4',
    right: '2',
    left: '2',
    rear: '6',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Roc',
    manufacturer: 'Blackburn',
    country: 'GB',
    years: 'April 1939-1943',
    spd: '4',
    man: '4',
    alt: '4',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '0',
    right: '4',
    left: '4',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Turret with 4 MGs',
  }),
  new Aircraft({
    type: 'Skua',
    manufacturer: 'Blackburn',
    country: 'GB',
    years: 'Nov 1938-1941',
    spd: '5',
    man: '4',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '4',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Defiant',
    manufacturer: 'Boulton Paul',
    country: 'GB',
    years: 'Okt 39- sept 40',
    spd: '6',
    man: '3',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '2',
    front: '0',
    right: '4',
    left: '4',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Turret with 4 MGs',
  }),
  new Aircraft({
    type: 'Beaufighter MkVI',
    manufacturer: 'Bristol',
    country: 'GB',
    years: 'Mid 1942',
    spd: '7',
    man: '3',
    alt: '4',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '14',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: '20mm',
    other: 'With wing guns fitted.',
  }),
  new Aircraft({
    type: 'Beaufighter MkX',
    manufacturer: 'Bristol',
    country: 'GB',
    years: '1943',
    spd: '7',
    man: '3',
    alt: '4',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '10',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: '20mm',
    other: 'No wing guns. 8 x rockets or 1 x Torpedo',
  }),
  new Aircraft({
    type: 'Beaufort',
    manufacturer: 'Bristol',
    country: 'GB',
    years: '1939-1944',
    spd: '5',
    man: '3',
    alt: '4',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Blenheim Mk I',
    manufacturer: 'Bristol',
    country: 'GB',
    years: '1937',
    spd: '6',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '3*',
    siz: '3',
    front: '1',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Blenheim Mk IF',
    manufacturer: 'Bristol',
    country: 'GB',
    years: '1939-juni 1940',
    spd: '6',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '5',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Blenheim Mk IV',
    manufacturer: 'Bristol',
    country: 'GB',
    years: '1940?',
    spd: '6',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '3',
    front: '1',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Blenheim Mk IVF',
    manufacturer: 'Bristol',
    country: 'GB',
    years: '1940?',
    spd: '6',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '3',
    front: '5',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Bulldog II',
    manufacturer: 'Bristol',
    country: 'GB',
    years: '1929',
    spd: '3',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '3',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '15',
    gun: 'MG',
    other: 'Only saw combat with the Finnish forces against the soviets.',
  }),
  new Aircraft({
    type: 'DH82 Tiger Moth',
    manufacturer: 'DeHavilland',
    country: 'GB',
    years: '1932-1959',
    spd: '2',
    man: '3',
    alt: '4',
    roc: '2',
    rob: '2',
    siz: '3',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: '-',
    other: 'Trainer',
  }),
  new Aircraft({
    type: 'Mosquito F MkII',
    manufacturer: 'DeHavilland',
    country: 'GB',
    years: 'Jan 1942',
    spd: '7',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '14',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Mosquito FB V1',
    manufacturer: 'DeHavilland',
    country: 'GB',
    years: '1943',
    spd: '8',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '14',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Mosquito Tsetse',
    manufacturer: 'DeHavilland',
    country: 'GB',
    years: '1944',
    spd: '7',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '8',
    gun: '6pdr',
    other: 'Rolls with 5 on damage table if hits',
  }),
  new Aircraft({
    type: 'Mosquito PRXVI',
    manufacturer: 'DeHavilland',
    country: 'GB',
    years: '1944',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: '-',
    other: 'Photo Reconnaissance Version',
  }),
  new Aircraft({
    type: 'Albacore',
    manufacturer: 'Fairey',
    country: 'GB',
    years: 'Mrt 40-1943',
    spd: '3',
    man: '3',
    alt: '4',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '1',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: '12',
    gun: 'MG',
    other: 'Replacement for the Swordfish. Torpedo bomber',
  }),
  new Aircraft({
    type: 'Barracuda MkII',
    manufacturer: 'Fairey',
    country: 'GB',
    years: '1943-1945',
    spd: '4',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '0',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'n/a',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Battle',
    manufacturer: 'Fairey',
    country: 'GB',
    years: 'Juni 1937-1940',
    spd: '4',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '3*',
    siz: '3',
    front: '0',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'n/a',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Firefly Mk I',
    manufacturer: 'Fairey',
    country: 'GB',
    years: '1943-1952',
    spd: '6',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Fulmar Mk I',
    manufacturer: 'Fairey',
    country: 'GB',
    years: 'May 1940-1945',
    spd: '5',
    man: '4*',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '8',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '14',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Sea Fox',
    manufacturer: 'Fairey',
    country: 'GB',
    years: '1937-1943',
    spd: '2',
    man: '3',
    alt: '3',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '0',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Spotter seaplane for Royal Navy ships',
  }),
  new Aircraft({
    type: 'Swordfish',
    manufacturer: 'Fairey',
    country: 'GB',
    years: '1936-1945',
    spd: '2',
    man: '3',
    alt: '4',
    roc: '2',
    rob: '4',
    siz: '2',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Gladiator',
    manufacturer: 'Gloster',
    country: 'GB',
    years: '1937-1941',
    spd: '5',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Meteor',
    manufacturer: 'Gloster',
    country: 'GB',
    years: '27 july 1944',
    spd: '10',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '2',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Halifax',
    manufacturer: 'Handley Page',
    country: 'GB',
    years: 'Nov 1940',
    spd: '5',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '6',
    siz: '6',
    front: '2',
    right: '1',
    left: '1',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Hampden',
    manufacturer: 'Handley Page',
    country: 'GB',
    years: '1938-1942',
    spd: '5',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '2',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Fury',
    manufacturer: 'Hawker',
    country: 'GB',
    years: '1931-1939',
    spd: '4',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Hart',
    manufacturer: 'Hawker',
    country: 'GB',
    years: '1930-1939',
    spd: '3',
    man: '4',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '1',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Hurricane I',
    manufacturer: 'Hawker',
    country: 'GB',
    years: '1939',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Hurricane IIB',
    manufacturer: 'Hawker',
    country: 'GB',
    years: 'Oktober 1940',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '11',
    gun: 'MG',
    other: 'Bombracks for 500lb bombs',
  }),
  new Aircraft({
    type: 'Hurricane IIC',
    manufacturer: 'Hawker',
    country: 'GB',
    years: 'Juni 1941',
    spd: '7',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '11',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Hurricane IID',
    manufacturer: 'Hawker',
    country: 'GB',
    years: '1942',
    spd: '7',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '8',
    gun: '40mm',
    other: '40mm Cannon version (2x 40mm underwing and 2 x MG in wing)',
  }),
  new Aircraft({
    type: 'Tempest V',
    manufacturer: 'Hawker',
    country: 'GB',
    years: 'April 1944',
    spd: '8',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '11',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in any manoeuvre that involves a gain in altitude.',
  }),
  new Aircraft({
    type: 'Tempest VI',
    manufacturer: 'Hawker',
    country: 'GB',
    years: '1945',
    spd: '9',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '11',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in any manoeuvre that involves a gain in altitude.',
  }),
  new Aircraft({
    type: 'Typhoon IB',
    manufacturer: 'Hawker',
    country: 'GB',
    years: '1942',
    spd: '8',
    man: '5*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'SPD can increase to 9 at ALT3 and below. MAN also increased to 6 at ALT 3 and below.',
  }),
  new Aircraft({
    type: 'Baltimore',
    manufacturer: 'Martin',
    country: 'GB',
    years: '1941-1945',
    spd: '5',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '4',
    right: '2',
    left: '2',
    rear: '2',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Maryland',
    manufacturer: 'Martin',
    country: 'GB',
    years: '1940-1945',
    spd: '6',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '3',
    siz: '4',
    front: '4',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Sterling',
    manufacturer: 'Short',
    country: 'GB',
    years: '1941-1946',
    spd: '5',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '6',
    siz: '6',
    front: '2',
    right: '1',
    left: '1',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Sunderland III',
    manufacturer: 'Short',
    country: 'GB',
    years: '1938-1967',
    spd: '5',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '6',
    siz: '7',
    front: '10',
    right: '2',
    left: '2',
    rear: '3',
    ammoLimit: '16',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Seafire III',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: 'Februari 1942',
    spd: '7',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '9',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'Spitfire I/IIA',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: 'Augustus 1938',
    spd: '7',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'Spitfire I/IIB (early)',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: '',
    spd: '7',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '5',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn. Thrown 1\'s count double when testing for gun jam.',
  }),
  new Aircraft({
    type: 'Spitfire I/IIB (late)',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: '',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '9',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn. First 1 thrown counts twice when testing for gun jam.',
  }),
  new Aircraft({
    type: 'Spitfire VA',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: 'Maart 1941',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn (94 gebouwd)',
  }),
  new Aircraft({
    type: 'Spitfire VB',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: 'Maart 1941',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '9',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn (3911 gebouwd)',
  }),
  new Aircraft({
    type: 'Spitfire VC',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: 'Maart 1941',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn (2467 gebouwd)',
  }),
  new Aircraft({
    type: 'Spitfire IX',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: 'Juli 1942',
    spd: '8',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'Spitfire XIVE',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: 'Januari 1944',
    spd: '9',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'Walrus',
    manufacturer: 'Supermarine',
    country: 'GB',
    years: '1937-1944',
    spd: '3',
    man: '3',
    alt: '4',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '1',
    right: '2',
    left: '2',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Wellesley',
    manufacturer: 'Vickers',
    country: 'GB',
    years: 'Apr 1937- Nov 1941',
    spd: '5',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '3',
    siz: '5',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Wellington',
    manufacturer: 'Vickers',
    country: 'GB',
    years: 'Okt 38-1953',
    spd: '5',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '5',
    siz: '5',
    front: '2',
    right: '1',
    left: '1',
    rear: '4',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Lysander III',
    manufacturer: 'Westland',
    country: 'GB',
    years: 'Juni 1938-1946',
    spd: '4',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '2',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '8',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Whirlwind I',
    manufacturer: 'Westland',
    country: 'GB',
    years: 'dec 1940-dec 1943',
    spd: '7',
    man: '3',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Counts as MAN4 at Altitude 2 and below.',
  }),
  new Aircraft({
    type: 'AR196A-5',
    manufacturer: 'Arado',
    country: 'Germany',
    years: 'Nov 38-1945',
    spd: '4',
    man: '3',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '5',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'AR234 Blitz',
    manufacturer: 'Arado',
    country: 'Germany',
    years: 'Sept 44-1945',
    spd: '9',
    man: '2',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '5',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Some had 2 x 20mm rear cannon(FF4)',
  }),
  new Aircraft({
    type: 'BA349 Natter',
    manufacturer: 'Bachem',
    country: 'Germany',
    years: 'Mrt 45',
    spd: '12',
    man: '1',
    alt: '6*',
    roc: '3',
    rob: '1*',
    siz: '1',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '24 rockets. Can only climb for first three turns after launch (ascent must be straight) then must descend one Alt Band every two turns minimum. Can\'t land. Pilot must bail out.',
  }),
  new Aircraft({
    type: 'BV138',
    manufacturer: 'Blohm & Voss',
    country: 'Germany',
    years: 'Okt 40-1945(?)',
    spd: '3',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '3',
    siz: '5',
    front: '3',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Do17-E',
    manufacturer: 'Dornier',
    country: 'Germany',
    years: '',
    spd: '5',
    man: '1',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '1',
    right: '2',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Do17-P',
    manufacturer: 'Dornier',
    country: 'Germany',
    years: '',
    spd: '5',
    man: '1',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '1',
    right: '2',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Do215',
    manufacturer: 'Dornier',
    country: 'Germany',
    years: '',
    spd: '6',
    man: '1',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '2',
    right: '2',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'FI156 Storch',
    manufacturer: 'Fieseler',
    country: 'Germany',
    years: '',
    spd: '2',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '1*',
    siz: '1',
    front: '0',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'FW189a2 Uhu',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: 'Aug 41-1945',
    spd: '4',
    man: '4*',
    alt: '5',
    roc: '2',
    rob: '4',
    siz: '3',
    front: '2',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: '12',
    gun: 'MG',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'FW190A-1',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: 'Juli 1941',
    spd: '8',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'MAN drops to 6 at ALT3 and below',
  }),
  new Aircraft({
    type: 'FW190A-2 and A3',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '',
    spd: '8',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'MAN drops to 6 at ALT3 and below',
  }),
  new Aircraft({
    type: 'FW190A-4',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '1942',
    spd: '8',
    man: '5*',
    alt: '6*',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'FW190A-4/R6',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '5',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '9',
    gun: '20mm',
    other: 'Pulk Zerstorer 2 x WGr21',
  }),
  new Aircraft({
    type: 'FW190A-4/U1',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '',
    spd: '8',
    man: '5*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: '2 x 550lb bombs or 4 x 110lb bombs',
  }),
  new Aircraft({
    type: 'FW190A-6',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '1943',
    spd: '8',
    man: '5*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '16',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'FW190A-8',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '',
    spd: '9',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '30mm',
    other: 'MAN drops to 6 at ALT3 and below',
  }),
  new Aircraft({
    type: 'FW190A-9',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '',
    spd: '8',
    man: '5*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '17',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '30mm',
    other: '',
  }),
  new Aircraft({
    type: 'FW190A-6/R6',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '1943',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Pulk Zerstorer 2 x WGr21',
  }),
  new Aircraft({
    type: 'FW190D',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: 'Augustus 1944',
    spd: '9',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '9',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'MAN drops to 6 at ALT3 and below',
  }),
  new Aircraft({
    type: 'TA152',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: 'Januari 1945',
    spd: '9',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '9',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'MAN drops to 5 at ALT3 and below. SPD increases to 10 at ALT 5 and 6',
  }),
  new Aircraft({
    type: 'FW200 Condor',
    manufacturer: 'Focke Wulf',
    country: 'Germany',
    years: '',
    spd: '4',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '5',
    siz: '6',
    front: '2',
    right: '2',
    left: '2',
    rear: '2',
    ammoLimit: 'N/A',
    gun: '20mm',
    other: '20mm in forward gondola',
  }),
  new Aircraft({
    type: 'He111',
    manufacturer: 'Heinkel',
    country: 'Germany',
    years: '',
    spd: '5',
    man: '1',
    alt: '6',
    roc: '1',
    rob: '5',
    siz: '5',
    front: '1',
    right: '1',
    left: '1',
    rear: '3',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'He115',
    manufacturer: 'Heinkel',
    country: 'Germany',
    years: '1939-1945',
    spd: '4',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '5',
    siz: '5',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'He162 (early)',
    manufacturer: 'Heinkel',
    country: 'Germany',
    years: '',
    spd: '10',
    man: '3',
    alt: '6*',
    roc: '1',
    rob: '3',
    siz: '1',
    front: '5',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '9',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'He162 (late)',
    manufacturer: 'Heinkel',
    country: 'Germany',
    years: '',
    spd: '10',
    man: '3',
    alt: '6*',
    roc: '1',
    rob: '3',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '8',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'He51',
    manufacturer: 'Heinkel',
    country: 'Germany',
    years: '',
    spd: '4',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '2',
    siz: '3',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'He59',
    manufacturer: 'Heinkel',
    country: 'Germany',
    years: '',
    spd: '3',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '6',
    front: '1',
    right: '1',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Hs123A',
    manufacturer: 'Henschel',
    country: 'Germany',
    years: '',
    spd: '4',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Hs129',
    manufacturer: 'Henschel',
    country: 'Germany',
    years: '',
    spd: '5',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '8',
    gun: 'MG',
    other: '30mm cannon',
  }),
  new Aircraft({
    type: 'Hs129B-3/Wa',
    manufacturer: 'Henschel',
    country: 'Germany',
    years: '',
    spd: '4',
    man: '3',
    alt: '4',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '6',
    gun: 'MG',
    other: '75mm cannon. 5 on damage chart',
  }),
  new Aircraft({
    type: 'Ho229 Gotha',
    manufacturer: 'Horten',
    country: 'Germany',
    years: 'prototypes only 1945',
    spd: '11',
    man: '2',
    alt: '6*',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: '30mm',
    other: 'Jet-rules and bonuses appy, R4M air-to-air rockets',
  }),
  new Aircraft({
    type: 'Ju-188A',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '6',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '2',
    right: '2',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-188D',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '6',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '2',
    right: '1',
    left: '1',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-188E',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '6',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '2',
    right: '1',
    left: '1',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-388J',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '7',
    man: '4',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '18',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-388K',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '7',
    man: '4',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '0',
    right: '0',
    left: '0',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-52 Float',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '1932-1945',
    spd: '3',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '0',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-52',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '1932-1945',
    spd: '3',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '0',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-87B/D Stuka',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '6',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '2',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-87G Stuka',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '5',
    man: '2',
    alt: '1',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '10',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '8',
    gun: 'MG',
    other: '37mm Cannon version',
  }),
  new Aircraft({
    type: 'Ju-88A-1',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '5',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '1',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ju-88A-4',
    manufacturer: 'Junkers',
    country: 'Germany',
    years: '',
    spd: '6',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '1',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Me163 Komet',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'Juli 1944',
    spd: '11',
    man: '3',
    alt: '6*',
    roc: '2',
    rob: '2*',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '9',
    gun: 'MG',
    other: 'Jet rules and bonuses apply',
  }),
  new Aircraft({
    type: 'Me262A-1A',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'Oktober 1944',
    spd: '10',
    man: '5',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '14',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '30mm',
    other: 'Jet rules and bonuses apply. Use damage chart modifier for 30mm cannon',
  }),
  new Aircraft({
    type: 'Me262A-1A/U5',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: '',
    spd: '10',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '20',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: '30mm',
    other: 'Jet rules and bonuses apply. Apply 30mm cannon for damage',
  }),
  new Aircraft({
    type: 'Me262A-Sturmvogel',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: '',
    spd: '10',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '30mm',
    other: 'Jet rules and bonuses apply. Apply 30mm cannon for damage',
  }),
  new Aircraft({
    type: 'Me323 Gigant',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: '1943-1944',
    spd: '2',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '5',
    siz: '7',
    front: '4',
    right: '4-6',
    left: '4-6',
    rear: '6-8',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Second number for left/right/rear is applicable when infantry is carried',
  }),
  new Aircraft({
    type: 'BF109B',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'Februari 1937',
    spd: '6',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF109C',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'November 1938',
    spd: '6',
    man: '6',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF109E-1',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'Februari 1939',
    spd: '7',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '5',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF109E-3',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: '1939',
    spd: '7',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF109E-4 Emil',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: '1939',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '9',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF109F',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'November 1940',
    spd: '7',
    man: '6*',
    alt: '6*',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF109G-1',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'Maart 1942',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF109G-6',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'Oktober 1942',
    spd: '7',
    man: '6*',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF109K-4',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: 'Oktober 1944',
    spd: '8',
    man: '6*',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '30mm',
    other: 'Tailing a/c get -1 to stay on tail in dive or Split-S.',
  }),
  new Aircraft({
    type: 'BF110C',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: '',
    spd: '7',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '10',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '14',
    gun: '20mm',
    other: 'Lufbery counts as simple manoeuvre',
  }),
  new Aircraft({
    type: 'BF110G-2/R3',
    manufacturer: 'Messerschmitt',
    country: 'Germany',
    years: '',
    spd: '7',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '12',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '8',
    gun: '30mm',
    other: 'Use damage chart modifier for 30mm cannon. Also 4 x Wg21 rockets',
  }),
  new Aircraft({
    type: 'P-24',
    manufacturer: 'PZL',
    country: 'Greece',
    years: '1933-1940',
    spd: '5',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'BA65',
    manufacturer: 'Breda',
    country: 'Italy',
    years: '',
    spd: '5',
    man: '3',
    alt: '4',
    roc: '1',
    rob: '2',
    siz: '3',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Z-1007 Alcione',
    manufacturer: 'Cant',
    country: 'Italy',
    years: '',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '0',
    right: '1',
    left: '1',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Z-501',
    manufacturer: 'Cant',
    country: 'Italy',
    years: '',
    spd: '3',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '1',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Z-506B Airone',
    manufacturer: 'Cant',
    country: 'Italy',
    years: '',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '5',
    front: '0',
    right: '1',
    left: '1',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ca-133',
    manufacturer: 'Caproni',
    country: 'Italy',
    years: '',
    spd: '3',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '4*',
    siz: '4',
    front: '0',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ca-148',
    manufacturer: 'Caproni',
    country: 'Italy',
    years: '',
    spd: '3',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ca-310',
    manufacturer: 'Caproni',
    country: 'Italy',
    years: '',
    spd: '4',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '4',
    front: '2',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'BR20',
    manufacturer: 'Fiat',
    country: 'Italy',
    years: '',
    spd: '5',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '1',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'CR32 Chirri',
    manufacturer: 'Fiat',
    country: 'Italy',
    years: '',
    spd: '4',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'CR42 Falcon',
    manufacturer: 'Fiat',
    country: 'Italy',
    years: '',
    spd: '6',
    man: '4',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'G50 Freccia',
    manufacturer: 'Fiat',
    country: 'Italy',
    years: '',
    spd: '5',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '5',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'G55 Centauro',
    manufacturer: 'Fiat',
    country: 'Italy',
    years: '',
    spd: '8',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '9',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'MAN counts as 6* at ALT 5 and above. May carry torpedo.',
  }),
  new Aircraft({
    type: 'MC200 Saetta',
    manufacturer: 'Macchi',
    country: 'Italy',
    years: '',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'MC200 Saetta (late)',
    manufacturer: 'Macchi',
    country: 'Italy',
    years: '',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'MC202 Folgore',
    manufacturer: 'Macchi',
    country: 'Italy',
    years: '',
    spd: '7',
    man: '5',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'RO37 bis',
    manufacturer: 'Meridionali',
    country: 'Italy',
    years: '',
    spd: '4',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '8',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'RO43',
    manufacturer: 'Meridionali',
    country: 'Italy',
    years: '',
    spd: '4',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '1',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'RE2005 Sagitarrio',
    manufacturer: 'Reggiane',
    country: 'Italy',
    years: '',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'SM73',
    manufacturer: 'Savoia Marchetti',
    country: 'Italy',
    years: '',
    spd: '3',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'SM79 Sparviero',
    manufacturer: 'Savoia Marchetti',
    country: 'Italy',
    years: '',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '1',
    right: '1',
    left: '1',
    rear: '2',
    ammoLimit: '10',
    gun: '20mm',
    other: 'Forward 1 x 20mm, remainder is MG',
  }),
  new Aircraft({
    type: 'SM81 Pipistrello',
    manufacturer: 'Savoia Marchetti',
    country: 'Italy',
    years: '',
    spd: '4',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '0',
    right: '1',
    left: '1',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'D3A1 Val',
    manufacturer: 'Aichi',
    country: 'Japan',
    years: '1940',
    spd: '5',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '2',
    front: '2',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'H8K1 Emily',
    manufacturer: 'Kawanishi',
    country: 'Japan',
    years: 'Februari 1942',
    spd: '5',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '6',
    siz: '7',
    front: '1',
    right: '1',
    left: '1',
    rear: '3',
    ammoLimit: 'N/A',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'H8K2 Emily',
    manufacturer: 'Kawanishi',
    country: 'Japan',
    years: 'Februari 1942',
    spd: '6',
    man: '1',
    alt: '5',
    roc: '2',
    rob: '6',
    siz: '7',
    front: '2',
    right: '3',
    left: '3',
    rear: '3',
    ammoLimit: 'N/A',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-32 Mary',
    manufacturer: 'Kawasaki',
    country: 'Japan',
    years: '1938-1942',
    spd: '5',
    man: '4',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '2',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-45 Nick',
    manufacturer: 'Kawasaki',
    country: 'Japan',
    years: 'Oct 1941-1945',
    spd: '7',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '6',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-61A Tony',
    manufacturer: 'Kawasaki',
    country: 'Japan',
    years: '1943-1945',
    spd: '7',
    man: '6',
    alt: '6*',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-61B Tony',
    manufacturer: 'Kawasaki',
    country: 'Japan',
    years: '1943-1945',
    spd: '7',
    man: '6',
    alt: '6*',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-61C Tony',
    manufacturer: 'Kawasaki',
    country: 'Japan',
    years: '1943-1945',
    spd: '7',
    man: '6',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-61D Tony',
    manufacturer: 'Kawasaki',
    country: 'Japan',
    years: '1943-1945',
    spd: '7',
    man: '6',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '11',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'N1K2-J George',
    manufacturer: 'Kawasaki',
    country: 'Japan',
    years: '1943-1945',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '2',
    front: '14',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'A5M Claude',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1937-1945',
    spd: '5',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1*',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: 'Hineri Komi manoeuvre counts as tricky manoeuvre',
  }),
  new Aircraft({
    type: 'A6M2 Zero',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: 'Juli 1940',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1*',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'A6M3 Zero',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: 'December 1941',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1*',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'A6M3a Zero',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: 'Februari 1942',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1*',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'A6M5 Zero',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1944',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'A6M5a Zero',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1944',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'A6M5b Zero',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1944',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '9',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'A6M5c Zero',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1944',
    spd: '7',
    man: '6*',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: 'Tailing a/c get -1 to stay on tail in Break Turn',
  }),
  new Aircraft({
    type: 'C5M Babs',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: 'Mei 1937-1945',
    spd: '6',
    man: '3',
    alt: '6',
    roc: '1',
    rob: '1',
    siz: '1',
    front: '0',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'F1M2 Pete',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1941',
    spd: '5',
    man: '6',
    alt: '5',
    roc: '2',
    rob: '1*',
    siz: '2',
    front: '2',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'G3M1 Nell',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1935-1945',
    spd: '4',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '2*',
    siz: '5',
    front: '0',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: 'N/A',
    gun: '20mm',
    other: '20mm in rear dorsal turret',
  }),
  new Aircraft({
    type: 'G3M3 Nell',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1935-1945',
    spd: '5',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '2',
    siz: '5',
    front: '0',
    right: '1',
    left: '1',
    rear: '2',
    ammoLimit: 'N/A',
    gun: '20mm',
    other: '20mm in rear dorsal turret',
  }),
  new Aircraft({
    type: 'G4M2 Betty',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: 'Juni 1941-1945',
    spd: '5',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '4*',
    siz: '5',
    front: '4',
    right: '3',
    left: '3',
    rear: '4',
    ammoLimit: 'N/A',
    gun: '20mm',
    other: '20mm in tail turret',
  }),
  new Aircraft({
    type: 'J2M3 Jack',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: 'December 1942-1945',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '14',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-21-Ia Sally',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1938',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '5',
    front: '1',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-21-Ib Sally',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1938',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '3*',
    siz: '5',
    front: '1',
    right: '0',
    left: '0',
    rear: '3',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-21-Ic Sally',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1938',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '3*',
    siz: '5',
    front: '1',
    right: '1',
    left: '1',
    rear: '3',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-21-IIa Sally',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: 'Juni 1940',
    spd: '6',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '3*',
    siz: '5',
    front: '1',
    right: '1',
    left: '1',
    rear: '3',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-21-IIb Sally',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1940',
    spd: '6',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '3*',
    siz: '5',
    front: '1',
    right: '1',
    left: '1',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-46-III Dinah',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: 'Juli 1941',
    spd: '7',
    man: '3',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '2',
    front: '0',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-51 Sonia (early)',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '1940',
    spd: '5',
    man: '4',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '8',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-51 Sonia (late)',
    manufacturer: 'Mitsubishi',
    country: 'Japan',
    years: '',
    spd: '5',
    man: '4',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'A6M2-N Rufe',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '1942',
    spd: '5',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'B5N1 Kate',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '1938',
    spd: '4',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '3',
    front: '0',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Some equipped with 2 x 7.7mm MG in wings so could have front FF of 2 with ammo limit of 10',
  }),
  new Aircraft({
    type: 'B5N2 Kate',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '1939',
    spd: '5',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '3',
    front: '0',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Some equipped with 2 x 7.7mm MG in wings so could have front FF of 2 with ammo limit of 10',
  }),
  new Aircraft({
    type: 'Ki-27 Nate',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '1937-1945',
    spd: '6',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-43-Ia Oscar',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: 'April 1941',
    spd: '6',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '2',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-43-Ib Oscar',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '',
    spd: '6',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '3',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-43-Ic Oscar',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '',
    spd: '6',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-43-II Oscar',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: 'November 1942',
    spd: '7',
    man: '6',
    alt: '6*',
    roc: '2',
    rob: '2*',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-43-IIIa Oscar',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: 'April 1944',
    spd: '7',
    man: '6',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-43-IIIb Oscar',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '',
    spd: '7',
    man: '6',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'Ki-84-Ia Frank',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '1944',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '15',
    gun: '20mm',
    other: '-1 when testing for engine failure',
  }),
  new Aircraft({
    type: 'Ki-84-Ic Frank',
    manufacturer: 'Nakajima',
    country: 'Japan',
    years: '',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '30mm',
    other: '-1 when testing for engine failure. Use damage chart modifier for 30mm cannon.',
  }),
  new Aircraft({
    type: 'D4Y2 Judy',
    manufacturer: 'Yokosuka',
    country: 'Japan',
    years: '1942-1945',
    spd: '6',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '2',
    front: '2',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'D4Y4',
    manufacturer: 'Yokosuka',
    country: 'Japan',
    years: '',
    spd: '7',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '2',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Special Strike Kamikaze',
  }),
  new Aircraft({
    type: 'B-339 C Buffalo',
    manufacturer: 'Brewster',
    country: 'Netherlands',
    years: '1941-1944',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: '75A-7 Hawk',
    manufacturer: 'Curtiss',
    country: 'Netherlands',
    years: 'Okt 39-1942',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '3',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P40N-5 Kittyhawk',
    manufacturer: 'Curtiss',
    country: 'Netherlands',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'DXXI',
    manufacturer: 'Fokker',
    country: 'Netherlands',
    years: '',
    spd: '5',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'F VIIb Trimotor',
    manufacturer: 'Fokker',
    country: 'Netherlands',
    years: '1932-1940?',
    spd: '2',
    man: '3',
    alt: '3',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Bombardement trainer in LuVA. Last destroyed May 1940',
  }),
  new Aircraft({
    type: 'G1',
    manufacturer: 'Fokker',
    country: 'Netherlands',
    years: '1939-1940',
    spd: '5',
    man: '3*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '2',
    front: '8',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '14',
    gun: 'MG',
    other: 'ROC corrected',
  }),
  new Aircraft({
    type: 'G1 (Wasp engines)',
    manufacturer: 'Fokker',
    country: 'Netherlands',
    years: '10 mei 1940',
    spd: '4',
    man: '3',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '2',
    front: '4',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '14',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'T-VIIIw',
    manufacturer: 'Fokker',
    country: 'Netherlands',
    years: '1939-1941?',
    spd: '3',
    man: '3',
    alt: '4',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P-11C',
    manufacturer: 'PZL',
    country: 'Poland',
    years: '',
    spd: '4',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P-23 Karas',
    manufacturer: 'PZL',
    country: 'Poland',
    years: '1936-1939',
    spd: '3',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '1',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P-37 Los',
    manufacturer: 'PZL',
    country: 'Poland',
    years: 'Mrt 39-1944',
    spd: '5',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '1',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P-39N Airacobra',
    manufacturer: 'Bell',
    country: 'Russia',
    years: '',
    spd: '8',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '15',
    gun: '30mm',
    other: '',
  }),
  new Aircraft({
    type: 'P-63 Kingcobra',
    manufacturer: 'Bell',
    country: 'Russia',
    years: '',
    spd: '7',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '13',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '15',
    gun: '30mm',
    other: '',
  }),
  new Aircraft({
    type: 'IL-10',
    manufacturer: 'Illusyhin',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '3',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '2',
    front: '8',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: '10',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'IL-4',
    manufacturer: 'Illusyhin',
    country: 'Russia',
    years: '',
    spd: '5',
    man: '2',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '1',
    right: '2',
    left: '2',
    rear: '2',
    ammoLimit: 'N/A',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'IL-2 Shturmovik',
    manufacturer: 'Illusyhin',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '3',
    alt: '4',
    roc: '2',
    rob: '4',
    siz: '3',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'IL-2-37 Shturmovik',
    manufacturer: 'Illusyhin',
    country: 'Russia',
    years: '',
    spd: '5',
    man: '2',
    alt: '4',
    roc: '2',
    rob: '5',
    siz: '3',
    front: '10',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '8',
    gun: '30mm',
    other: '37mm Cannon version',
  }),
  new Aircraft({
    type: 'IL-2M3 Shturmovik',
    manufacturer: 'Illusyhin',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '3',
    alt: '4',
    roc: '2',
    rob: '4',
    siz: '3',
    front: '8',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '16',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'LA-5',
    manufacturer: 'Lavochkin',
    country: 'Russia',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '5',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'SPD increase to 8 at ALT3 and below. Some versions upgunned could be FF=7',
  }),
  new Aircraft({
    type: 'LA-7',
    manufacturer: 'Lavochkin',
    country: 'Russia',
    years: '',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'LaGG-3',
    manufacturer: 'Lavochkin',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '5',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: 'SPD = 7 at ALT3 and below.',
  }),
  new Aircraft({
    type: 'Mig 1 (and Mig 3)',
    manufacturer: 'Mikoyan',
    country: 'Russia',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: 'MG',
    other: 'MAN rating reduces to 4 at ALT 1 and 2',
  }),
  new Aircraft({
    type: 'Pe-2',
    manufacturer: 'Petlyakov',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '3',
    front: '2',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Pe-8(Ant-42)',
    manufacturer: 'Petlyakov',
    country: 'Russia',
    years: '',
    spd: '4',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '6',
    siz: '6',
    front: '1',
    right: '1',
    left: '1',
    rear: '4',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Dorsal and tail 20mm. Remainder MG',
  }),
  new Aircraft({
    type: 'I-15',
    manufacturer: 'Polikarpov',
    country: 'Russia',
    years: '',
    spd: '5',
    man: '6',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'I-153 Chaika',
    manufacturer: 'Polikarpov',
    country: 'Russia',
    years: '',
    spd: '5',
    man: '6',
    alt: '5',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'I-16 Rata',
    manufacturer: 'Polikarpov',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: 'MAN = 6 at ALT2 and below',
  }),
  new Aircraft({
    type: 'I-16 Rata (cannon)',
    manufacturer: 'Polikarpov',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '10',
    gun: '20mm',
    other: 'MAN 6 at ALT2 and below',
  }),
  new Aircraft({
    type: 'Su-2',
    manufacturer: 'Sukhoi',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '2',
    front: '4',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'SB-2 bis',
    manufacturer: 'Tupolev',
    country: 'Russia',
    years: '',
    spd: '5',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '3*',
    siz: '3',
    front: '3',
    right: '2',
    left: '2',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'TB3',
    manufacturer: 'Tupolev',
    country: 'Russia',
    years: '1932-1945',
    spd: '2',
    man: '1',
    alt: '4',
    roc: '0.5',
    rob: '6',
    siz: '7',
    front: '2',
    right: '6',
    left: '6',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'TU-2S',
    manufacturer: 'Tupolev',
    country: 'Russia',
    years: '',
    spd: '6',
    man: '3',
    alt: '6',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '4',
    right: '0',
    left: '0',
    rear: '6',
    ammoLimit: '12',
    gun: '20mm',
    other: '20mm forward. Remainder MG',
  }),
  new Aircraft({
    type: 'Yak-1',
    manufacturer: 'Yakolev',
    country: 'Russia',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '7',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Counts as MAN6 at Altitude 2 and below. SPD -1 at ALT4 and above',
  }),
  new Aircraft({
    type: 'Yak-3',
    manufacturer: 'Yakolev',
    country: 'Russia',
    years: '',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Counts as MAN6 at Altitude 2 and below. SPD -1 at ALT4 and above',
  }),
  new Aircraft({
    type: 'Yak-7BS',
    manufacturer: 'Yakolev',
    country: 'Russia',
    years: '',
    spd: '7',
    man: '5',
    alt: '4',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Counts as MAN6 at Altitude 2 and below. SPD -1 at ALT4 and above',
  }),
  new Aircraft({
    type: 'Yak-9',
    manufacturer: 'Yakolev',
    country: 'Russia',
    years: '',
    spd: '9',
    man: '5*',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: '20mm',
    other: 'Counts as MAN6 at Altitude 2 and below.',
  }),
  new Aircraft({
    type: 'B-339 E Buffalo',
    manufacturer: 'Brewster',
    country: 'UK',
    years: '',
    spd: '6',
    man: '5',
    alt: '5',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B-339 E Buffalo (light)',
    manufacturer: 'Brewster',
    country: 'UK',
    years: '',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '6',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: 'Lightened version',
  }),
  new Aircraft({
    type: 'P-39C Airacobra',
    manufacturer: 'Bell',
    country: 'USA',
    years: '',
    spd: '7',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '15',
    gun: '30mm',
    other: '',
  }),
  new Aircraft({
    type: 'P-39D Airacobra',
    manufacturer: 'Bell',
    country: 'USA',
    years: '',
    spd: '7',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '15',
    gun: '30mm',
    other: '',
  }),
  new Aircraft({
    type: 'P-400 Airacobra',
    manufacturer: 'Bell',
    country: 'USA',
    years: '',
    spd: '7',
    man: '4',
    alt: '4',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '10',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '15',
    gun: '30mm',
    other: '',
  }),
  new Aircraft({
    type: 'B-17D Flying Fortress',
    manufacturer: 'Boeing',
    country: 'USA',
    years: '',
    spd: '5',
    man: '1',
    alt: '6',
    roc: '1',
    rob: '6',
    siz: '6',
    front: '4',
    right: '6',
    left: '6',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B-17E/F Flying Fortress',
    manufacturer: 'Boeing',
    country: 'USA',
    years: '',
    spd: '5',
    man: '1',
    alt: '6',
    roc: '1',
    rob: '6',
    siz: '6',
    front: '4',
    right: '6',
    left: '6',
    rear: '8',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B-17G Flying Fortress',
    manufacturer: 'Boeing',
    country: 'USA',
    years: '',
    spd: '6',
    man: '1',
    alt: '6',
    roc: '1',
    rob: '6',
    siz: '6',
    front: '6',
    right: '6',
    left: '6',
    rear: '8',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B-29 Superfortress',
    manufacturer: 'Boeing',
    country: 'USA',
    years: '',
    spd: '6',
    man: '1',
    alt: '6',
    roc: '1',
    rob: '6',
    siz: '7',
    front: '6',
    right: '8',
    left: '8',
    rear: '10',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'F2A-2 Buffalo',
    manufacturer: 'Brewster',
    country: 'USA',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'F2A-3 Buffalo',
    manufacturer: 'Brewster',
    country: 'USA',
    years: '',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B-24J Liberator',
    manufacturer: 'Consolidated',
    country: 'USA',
    years: '',
    spd: '5',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '6*',
    siz: '6',
    front: '5',
    right: '6',
    left: '6',
    rear: '8',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'PBY Catalina',
    manufacturer: 'Consolidated',
    country: 'USA',
    years: '',
    spd: '3',
    man: '1',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '2',
    right: '1',
    left: '1',
    rear: '1',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P36 Mohawk',
    manufacturer: 'Curtiss',
    country: 'USA',
    years: 'Apr 38 – dec 1941',
    spd: '6',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '3',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P40 Tomahawk I',
    manufacturer: 'Curtiss',
    country: 'USA',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '4',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P40C Tomahawk',
    manufacturer: 'Curtiss',
    country: 'USA',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2*',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P40D Kittyhawk',
    manufacturer: 'Curtiss',
    country: 'USA',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P40E Kittyhawk',
    manufacturer: 'Curtiss',
    country: 'USA',
    years: '',
    spd: '7',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P40N-1 Kittyhawk',
    manufacturer: 'Curtiss',
    country: 'USA',
    years: '',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: 'MG',
    other: '',
  }),
  // new Aircraft({
  //   type: 'P40N-5 Kittyhawk',
  //   manufacturer: 'Curtiss',
  //   country: 'USA',
  //   years: '',
  //   spd: '7',
  //   man: '5',
  //   alt: '6',
  //   roc: '2',
  //   rob: '2',
  //   siz: '1',
  //   front: '12',
  //   right: '0',
  //   left: '0',
  //   rear: '0',
  //   ammoLimit: '16',
  //   gun: 'MG',
  //   other: '',
  // }),
  new Aircraft({
    type: 'SB2C-1 Helldiver',
    manufacturer: 'Curtiss',
    country: 'USA',
    years: '',
    spd: '5',
    man: '4',
    alt: '5',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '8',
    right: '2',
    left: '2',
    rear: '2',
    ammoLimit: '18',
    gun: 'MG',
    other: 'Also available as cannon armed version (FF of 5 with ammo limit 12)',
  }),
  new Aircraft({
    type: 'A-20G Boston/Havoc',
    manufacturer: 'Douglas',
    country: 'USA',
    years: '',
    spd: '6',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '4',
    front: '12',
    right: '4',
    left: '4',
    rear: '4',
    ammoLimit: '16',
    gun: 'MG',
    other: 'Speed corrected',
  }),
  new Aircraft({
    type: 'C-47 Dakota',
    manufacturer: 'Douglas',
    country: 'USA',
    years: '',
    spd: '4',
    man: '1',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '5',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'SBD Dauntless',
    manufacturer: 'Douglas',
    country: 'USA',
    years: '1940',
    spd: '5',
    man: '3',
    alt: '5',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: 'Rear FF = 2 Post 1943',
  }),
  new Aircraft({
    type: 'TBD-1 Devastator',
    manufacturer: 'Douglas',
    country: 'USA',
    years: 'August 1937',
    spd: '4',
    man: '3',
    alt: '5',
    roc: '1',
    rob: '1',
    siz: '2',
    front: '1',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '12',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'F4F-3 Wildcat',
    manufacturer: 'Grumman',
    country: 'USA',
    years: 'Sept 1940',
    spd: '7',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '18',
    gun: 'MG',
    other: 'Midway',
  }),
  new Aircraft({
    type: 'F4F-3A Wildcat',
    manufacturer: 'Grumman',
    country: 'USA',
    years: '',
    spd: '6',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '1',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '18',
    gun: 'MG',
    other: 'Midway',
  }),
  new Aircraft({
    type: 'F4F-4 Wildcat',
    manufacturer: 'Grumman',
    country: 'USA',
    years: '1942',
    spd: '6',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: 'Midway',
  }),
  new Aircraft({
    type: 'F6F-5 Hellcat',
    manufacturer: 'Grumman',
    country: 'USA',
    years: '1943',
    spd: '8',
    man: '5*',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '14',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'TBF Avenger',
    manufacturer: 'Grumman',
    country: 'USA',
    years: '1942',
    spd: '5',
    man: '3*',
    alt: '5',
    roc: '1',
    rob: '3',
    siz: '3',
    front: '6',
    right: '0',
    left: '0',
    rear: '1',
    ammoLimit: '15',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'Hudson',
    manufacturer: 'Lockheed',
    country: 'USA',
    years: '',
    spd: '4',
    man: '2',
    alt: '4',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '2',
    right: '2',
    left: '2',
    rear: '2',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P-38G Lightning',
    manufacturer: 'Lockheed',
    country: 'USA',
    years: '',
    spd: '8',
    man: '4',
    alt: '6',
    roc: '2',
    rob: '3*',
    siz: '1',
    front: '11',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'P-38L Lightning',
    manufacturer: 'Lockheed',
    country: 'USA',
    years: '',
    spd: '8',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '11',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: '20mm',
    other: '',
  }),
  new Aircraft({
    type: 'P-51B/C Mustang',
    manufacturer: 'North American',
    country: 'USA',
    years: '',
    spd: '8',
    man: '6*',
    alt: '6*',
    roc: '2',
    rob: '2',
    siz: '1',
    front: '8',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: 'MG',
    other: 'MAN drops to 6 at ALT2 and below',
  }),
  new Aircraft({
    type: 'P-51D Mustang',
    manufacturer: 'North American',
    country: 'USA',
    years: '',
    spd: '9',
    man: '6*',
    alt: '6*',
    roc: '2',
    rob: '3',
    siz: '1',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '18',
    gun: 'MG',
    other: 'MAN drops to 6 at ALT2 and below',
  }),
  new Aircraft({
    type: 'L-4 Grasshopper',
    manufacturer: 'Piper',
    country: 'USA',
    years: '',
    spd: '2',
    man: '2',
    alt: '2',
    roc: '1',
    rob: '1*',
    siz: '1',
    front: '0',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'P-47D Thunderbolt',
    manufacturer: 'Republic',
    country: 'USA',
    years: '',
    spd: '9',
    man: '5',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '16',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '18',
    gun: 'MG',
    other: 'SPD+2 if move includes dive. MAN = 5 at ALT2 and below.',
  }),
  new Aircraft({
    type: 'P-47M Thunderbolt',
    manufacturer: 'Republic',
    country: 'USA',
    years: '',
    spd: '9',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '18',
    gun: 'MG',
    other: 'SPD+2 if move includes dive. MAN = 5 at ALT2 and below.',
  }),
  new Aircraft({
    type: 'F4U-1 Corsair',
    manufacturer: 'Vought',
    country: 'USA',
    years: '',
    spd: '8',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'F4U-1D Corsair',
    manufacturer: 'Vought',
    country: 'USA',
    years: '',
    spd: '9',
    man: '6',
    alt: '6',
    roc: '2',
    rob: '3',
    siz: '2',
    front: '12',
    right: '0',
    left: '0',
    rear: '0',
    ammoLimit: '16',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'SB2U-3 Vindicator',
    manufacturer: 'Vought',
    country: 'USA',
    years: '1937-1945',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '2',
    siz: '2',
    front: '2',
    right: '0',
    left: '0',
    rear: '2',
    ammoLimit: '10',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B26B Marauder',
    manufacturer: 'Martin',
    country: 'USA/GB',
    years: '',
    spd: '6',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '10',
    right: '4',
    left: '4',
    rear: '6',
    ammoLimit: '18',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B26G Marauder',
    manufacturer: 'Martin',
    country: 'USA/GB',
    years: '',
    spd: '6',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '12',
    right: '4',
    left: '4',
    rear: '6',
    ammoLimit: '20',
    gun: 'MG',
    other: '',
  }),
  new Aircraft({
    type: 'B-25B Mitchell',
    manufacturer: 'North American',
    country: 'USA/GB',
    years: '',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '4',
    right: '4',
    left: '4',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Mitchell I',
  }),
  new Aircraft({
    type: 'B-25C/D Mitchell',
    manufacturer: 'North American',
    country: 'USA/GB',
    years: '',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '6',
    right: '4',
    left: '4',
    rear: '4',
    ammoLimit: 'N/A',
    gun: 'MG',
    other: 'Mitchell II',
  }),
  new Aircraft({
    type: 'B-25J Mitchell',
    manufacturer: 'North American',
    country: 'USA/GB',
    years: '',
    spd: '5',
    man: '2',
    alt: '5',
    roc: '1',
    rob: '4',
    siz: '4',
    front: '24',
    right: '4',
    left: '4',
    rear: '4',
    ammoLimit: '20',
    gun: 'MG',
    other: '',
  }),
];
Aircrafts.sort((a, b) => a.type.localeCompare(b.type));
export default Aircrafts;
